module.exports = "/assets/data/1654e47c0f094114f24134bd1f4efda2-CA18.data.json";